package org.matthewo.config

import kotlinx.serialization.Serializable

@Suppress("PropertyName")
@Serializable
data class SiteConfig(
    val CURRENT_YEAR: Int,
    // the server's public key for web push, base64url; null when the server can't send notifications
    val WEB_PUSH_KEY: String? = null,
)
